import React, { useEffect, useState } from 'react'
import MainContentWrapper from '../../../Components/MainContentWrapper'
import DatePicker from "react-datepicker"
import calender from "../../../assets/calender-new.svg";
import search from "../../../assets/search.svg";
import SelectComponent from '../../../ReusableComponents/SelectComponent';
import { getBesIncentives } from '../../../apis/requests';
import TableView from '../../../ReusableComponents/TableView/TableView';
import Popup from "../../../ReusableFunctions/Popup";
import { getIncentiveStatusColor } from '../../../ReusableFunctions/reusableFunctions';
import { useNavigate } from 'react-router';
import { ROUTES } from '../../../routes';
import { BES_INCENTIVE_STATUS } from '../../../appConstants';

const statusOptions=[
  {label:"All",value:undefined},
  {label:"Pending",value:"Pending"},
  {label:"Paid",value:"Submitted"},
]
export default function DspIncentives() {
  const [incentives, setIncentives] = useState([])
  const navigate=useNavigate();
  const [loading, setLoading] = useState(false);
   const [openDatePicker, setOpenDatePicker] = useState({
      fromDate: false,
      toDate: false,
    });

    const [filters, setFilters] = useState({
      pageNumber:1,
      pageSize:15,
      status:[],
      searchQuery:'',
    })
    const [filterDateTime, setFilterDateTime] = useState({ fromDate: undefined, toDate: undefined })

  const getIncentivesAPI = async (
    pageSize,
    pageNumber,
    searchQuery,
    status,
    fromDate,
    toDate
  ) => {
    try {
      setLoading(true);
      const {data} = await getBesIncentives (
      pageNumber,
      pageSize,
      searchQuery,
      status,
      fromDate,
      toDate,
      );
      let incentivesData = data.incentives;
     setIncentives(incentivesData);
      setLoading(false);
    } catch (err) {
      console.log("errr:", err);
      setLoading(false);
      Popup.alert("Error", err, "ERROR");
    }
  };


  useEffect(()=>{
   getIncentivesAPI(
    filters.pageSize,filters.pageNumber,filters.searchQuery,
    filters.status,filterDateTime && 
    filterDateTime.fromDate ? new Date(filterDateTime.fromDate).toISOString() : undefined,
    filterDateTime && filterDateTime.toDate ? new Date(filterDateTime.toDate).toISOString(): undefined);
  },[filters.pageSize,filters.pageNumber,filters.searchQuery,filters.status,filterDateTime.fromDate,filterDateTime.toDate])

  let selectedOption
  if(filters.status && filters?.status?.length>0){
    selectedOption=statusOptions?.find((st)=>st?.value===filters?.status[0])
  }else {
    selectedOption=undefined;
  }
  return (
    <MainContentWrapper header={"Incentives"}>
     <div className='h-[100%] bg-white rounded-[16px]'>
      <div className='py-4 px-6 flex justify-between items-center'>
       <h4 className='w-[20%] font-manrope text-[#1E1E1E] font-[600]'>All Incentives</h4>
       <div className='w-[80%] flex justify-end gap-4 '>
        <div className="">
          <SelectComponent
            controlStyle={{
              height: "30px",
              width: "200px",
              backgroundColor:"#FAFAFA",
              minHeight: "20px",
              border: "none",
              boxShadow: "0px 2px 5px 1px #6273943d",
              color: "hsl(0deg 0% 20% / 64%)",
              fontSize: "10px",
              padding: "0px 3px",
            }}
            isSearchable={true}
            value={ filters.status?.length===0?{label:"All",value:null}:selectedOption }
            placeholder={"Select status "}
            menuPlacement={"bottom"}
            list={statusOptions}
            onChange={(status) => {
              setFilters((prevFilters)=>{
                return {
                  ...prevFilters,
                  status:status?.value?[status?.value]:undefined,
                  pageNumber:1
                }
              })
            }}
          />
        </div>
         <div style={{ position: "relative", height: "30px", width: "30%",background:"#FAFAFA" }}>
              <img
                src={search}
                alt="search icon"
                style={{ position: "absolute", left: "20px", top: "5px" }}
              />
              <input
                value={filters.searchQuery}
                onChange={(e) => {
                  setFilters((prevFilters)=>{
                    return {
                      ...prevFilters,
                      pageNumber:1,
                      searchQuery:e.target.value
                    }
                  })
                }}
                placeholder="Search request by request no..."
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "4px",
                  border: "1px solid #BFC8D9",
                  padding: "10px 10px 10px 60px",
                  fontSize: "12px",
                }}
              />
        </div>
        <div className="date_Filters">
            <div
              className="input-date "
              style={{
                display: "flex",
                fonrSize: "14px",
                alignItems: "center",
                cursor: "pointer",
                height: "25px",
                width: "150px",
                zIndex:9,
                position: "relative",
                background: "transparent",
              }}
              onClick={() =>
                setOpenDatePicker((prev) => ({ ...prev, fromDate: true }))
              }
            >
              <DatePicker
                onClickOutside={() =>
                  setOpenDatePicker((prev) => ({ ...prev, fromDate: false }))
                }
                open={openDatePicker.fromDate}
                placeholderText="From Date"
                maxDate={filterDateTime?.toDate && new Date(filterDateTime?.toDate)}
                readOnly
                showMonthDropdown 
                showYearDropdown 
                dropdownMode="select"
                className="input-date-hidden"
                dateFormat="dd/MM/yyyy"
                selected={
                  filterDateTime.fromDate ? new Date(filterDateTime.fromDate) : null
                }
                onChange={(date) => {
                  if (date) {
                    let fromDate = new Date(date).setHours(0, 0, 0, 0);
                    fromDate = new Date(fromDate).toISOString();
                    const updatedDateTime = { ...filterDateTime, fromDate };
                    setFilters((prevFilters)=>{
                      return {
                        ...prevFilters,
                        pageNumber:1
                      }
                    })
                    setFilterDateTime(updatedDateTime);
                  }
                }}
              />
              <img
                src={calender}
                style={{ width: "15px", position: "absolute", right: "15px" }}
              />
            </div>
            <div className="text-xl font-thin">-</div>
            <div
              className="input-date  "
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                height: "25px",
                width: "150px",
                position: "relative",
                background: "transparent",
                zIndex: 9,
              }}
              onClick={() => {
                if (filterDateTime?.fromDate) {
                  setOpenDatePicker((prev) => ({ ...prev, toDate: true }));
                }
              }}
            >
              <DatePicker
                placeholderText="To Date"
                onClickOutside={() =>
                  setOpenDatePicker((prev) => ({ ...prev, toDate: false }))
                }
                open={openDatePicker.toDate}
                disabled={!filterDateTime.fromDate}
                minDate={filterDateTime?.fromDate && new Date(filterDateTime?.fromDate)}
                style={{ zIndex: 1000 }}
                readOnly
                showMonthDropdown // 🔹 Allows selecting months when clicking on month
                showYearDropdown // 🔹 Allows selecting years when clicking on year
                dropdownMode="select"
                className="input-date-hidden "
                dateFormat="dd/MM/yyyy"
                selected={filterDateTime.toDate ? new Date(filterDateTime.toDate) : null}
                onChange={(date) => {
                  if (date) {
                    let toDate = new Date(date).setHours(23, 59, 59, 999);
                    toDate = new Date(toDate).toISOString();
                    const updatedDateTime = { ...filterDateTime, toDate };
                    setFilters((prevFilters)=>{
                      return {
                        ...prevFilters,
                        pageNumber:1
                      }
                    })
                    setFilterDateTime(updatedDateTime)
                  }
                }}
              />
              <img
                src={calender}
                style={{ width: "15px", position: "absolute", right: "15px" }}
              />
            </div>
          </div>
          
       </div>
      </div>
      <div className='h-[90%]'>
        <TableView
        loadingHeight={"500px"}
        isLoading={loading}
        onStateChange={async (changedState) => {
          const { pageNumber } = changedState;
          setFilters((prevFilters)=>({
           ...prevFilters,
           pageNumber:pageNumber
          }))
        }}
        onClickRow={(incentive) => {
          navigate(`${ROUTES.INCENTIVESOVERVIEW}`, {
            state: {
              incentive: incentive,
              filters: {
                ...filters,
                status:filters?.status
              },
            },
          });
        }}
        columns={[
          { Header: "Order No.", accessor: "od_number" },
          { Header: "Location", accessor: "field_name" },
          { Header: "BES Name", accessor: "bes_name" },
          {
            Header: "Date",
            accessor: "date_added",
            isDate: true,
            format: "dd/mm/yyyy",
          },
          { Header: "Amount", accessor: "inc_amount" },
          { Header: "Status", accessor: "updated_status", showColor: true },
        ]}
        count={incentives[0]?.total_count || 0}
        pageSize={filters.pageSize}
        pageNumber={filters.pageNumber || undefined}
        data={incentives?.map((req) => ({
          ...req,
          od_number:`#${req.order_number}`,
          inc_amount:`₹ ${req.amount}`,
          updated_status:req.status===BES_INCENTIVE_STATUS.SUBMITTED?"Paid":req.status,
          color: getIncentiveStatusColor(req.status, true),
        }))}
        tableContainerHeight={"530px"}
        hidePagination={false}
      />
      </div>
      </div> 
    </MainContentWrapper>
  )
}
